/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosDueTasksDueTaskDto,
  FacilityFlowCoreModulesPlanningDtosDueTasksObjectDueMinutesDto,
  GetApiV1DueTasksObjectMinutesParams,
  GetApiV1DueTasksParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getDueTasks = () => {
const getApiV1DueTasks = (
    params?: GetApiV1DueTasksParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosDueTasksDueTaskDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosDueTasksDueTaskDto[]>(
      {url: `/api/v1/due-tasks`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Minutes due per object in the week according to the schedule rules, planned or not.
 */
const getApiV1DueTasksObjectMinutes = (
    params?: GetApiV1DueTasksObjectMinutesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosDueTasksObjectDueMinutesDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosDueTasksObjectDueMinutesDto[]>(
      {url: `/api/v1/due-tasks/object-minutes`, method: 'GET',
        params
    },
      options);
    }
  return {getApiV1DueTasks,getApiV1DueTasksObjectMinutes}};
export type GetApiV1DueTasksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDueTasks>['getApiV1DueTasks']>>>
export type GetApiV1DueTasksObjectMinutesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDueTasks>['getApiV1DueTasksObjectMinutes']>>>
